import { registerAction } from '../../Action'

const REGISTER_DROP_DATA = 'REGISTER_DROP_DATA'

const reducer = (state = {}, action) => ({
  ...state,
  dropData: action.payload,
})

const registerDropData = registerAction(REGISTER_DROP_DATA, { reducer })

export default registerDropData
